// extracted by mini-css-extract-plugin
export default {"allocationSummary":"_nVBjUPltsAPg0NPCgqP","allocationHeader":"S5daTyMEWtU9739fDuQ2","allocationTitle":"p82KjCxqpmLsFjqnvpb9","statsInfo":"UqRi3lbjLyKrpk_byAvq"};